module.exports = __webpack_public_path__ + "static/media/ID Card front_.2589e76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ID Card front_.png
// module id = 644
// module chunks = 0 1